import React from 'react';
import { Container, Image, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { newsList } from '../data/news/NewsList';
import '../css/News.css';
import NewsList from '../components/NewsList';

function News() {
    return <Container>
        <h2>News</h2>
        <NewsList />
    </Container>;

}




export default News;